/* eslint-disable react/no-unknown-property */
/* eslint-disable react/self-closing-comp */
import React from 'react'
import { PiTelegramLogoFill } from 'react-icons/pi'
import { BsFillTelephoneFill } from 'react-icons/bs'
import { IoMail, IoChatbox } from 'react-icons/io5'
import { GoClockFill } from 'react-icons/go'
import { MdPlace } from 'react-icons/md'

import ContainerSectionContactCircular from './styles'
import useAppConfig from '../../../../hooks/useAppConfig'
import ArrowCurvedSVG from '../../../../assets/svgs/arrow-curved'
import { logFirebaseEvent } from '../../../../services/firebase/analytics'

export default function SectionContactCircular() {
  const { appConfig } = useAppConfig()

  const {
    fullNameLabel: formNameLabel,
    phoneNumberLabel: formPhonenumberLabel,
    emailLabel: formEmailLabel,
    messageLabel: formMessageLabel,
    messagePlaceholder: formMessagePlaceholder,
    actionSubmit: formActionSubmit,
  } = appConfig?.appConfig?.contacts?.form ?? {}

  const {
    label: screenLabel,
    title: screenTitle,
    description: screenDescription,
    telephone: screenTelephone,
    telephoneLabel: screenTelephoneLabel,
    email: screenEmail,
    emailLabel: screenEmailLabel,
    openHours: screenOpenHours,
    openHoursLabel: screenOpenHoursLabel,
    location: screenLocation,
    locationLabel: screenLocationLabel,
  } = appConfig?.appConfig?.contacts ?? {}

  const handleANalyticsButtonClick = () => {
    logFirebaseEvent('form_submit', {
      form_name: 'contact_form',
      screen_name: 'landing_page',
      submission_status: 'success',
    })
  }

  return (
    <ContainerSectionContactCircular
      color={
        appConfig?.appConfig?.styles?.forceSecondaryColor ? 'true' : undefined
      }
    >
      <div className="middle-section">
        <div className="m-s-left">
          {/* @ts-ignore */}
          <form className="box-form" autoComplete="off" netlify>
            <div className="double-input">
              <div className="box-input-global">
                <div className="box-input-label">{formNameLabel} *</div>
                <input type="text" placeholder={formNameLabel} />
                <div className="box-input-icon-float">
                  <PiTelegramLogoFill />
                </div>
              </div>
              <div className="box-input-global">
                <div className="box-input-label">
                  {formPhonenumberLabel} (opcional)
                </div>
                <input type="tel" placeholder={formPhonenumberLabel} />
                <div className="box-input-icon-float">
                  <BsFillTelephoneFill />
                </div>
              </div>
            </div>
            <div className="box-input-global">
              <div className="box-input-label">{formEmailLabel} *</div>
              <input type="email" placeholder={formEmailLabel} />
              <div className="box-input-icon-float">
                <IoMail />
              </div>
            </div>
            <div className="box-input-global">
              <div className="box-input-label">{formMessageLabel} *</div>
              <textarea placeholder={formMessagePlaceholder}></textarea>
              <div className="box-input-icon-float textarea">
                <IoChatbox />
              </div>
            </div>
            <div
              className="form-button"
              onClick={() => {
                handleANalyticsButtonClick()
              }}
              aria-hidden
            >
              {formActionSubmit}
            </div>
          </form>
        </div>
        <div className="m-s-right">
          <div className="m-s-r-label">
            {screenLabel}
            <span>
              <ArrowCurvedSVG />
            </span>
          </div>
          <div className="m-s-r-title">{screenTitle}</div>
          <div className="m-s-r-description">{screenDescription}</div>
          <div className="m-s-r-box-location">
            <div className="m-s-r-location-item">
              <div className="m-s-r-location-icon-left">
                <BsFillTelephoneFill />
              </div>
              <div className="m-s-r-location-data-right">
                <div className="title">{screenTelephone}</div>
                <div className="data">{screenTelephoneLabel}</div>
              </div>
            </div>
            <div className="m-s-r-location-item">
              <div className="m-s-r-location-icon-left">
                <GoClockFill />
              </div>
              <div className="m-s-r-location-data-right">
                <div className="title">{screenOpenHours}</div>
                <div className="data">{screenOpenHoursLabel}</div>
              </div>
            </div>
            <div className="m-s-r-location-item">
              <div className="m-s-r-location-icon-left">
                <IoMail />
              </div>
              <div className="m-s-r-location-data-right">
                <div className="title">{screenEmail}</div>
                <div className="data">{screenEmailLabel}</div>
              </div>
            </div>
            <div className="m-s-r-location-item">
              <div className="m-s-r-location-icon-left">
                <MdPlace />
              </div>
              <div className="m-s-r-location-data-right">
                <div className="title">{screenLocation}</div>
                <div className="data">{screenLocationLabel}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContainerSectionContactCircular>
  )
}
